var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    { attrs: { value: _vm.dialog, "max-width": "620", persistent: "" } },
    [
      _c(
        "v-card",
        { staticClass: "up-card" },
        [
          _c(
            "v-form",
            {
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.upload.apply(null, arguments)
                },
              },
            },
            [
              _c("div", { staticClass: "up-header" }, [
                _c("h1", [_vm._v("Carga individual de recibo")]),
              ]),
              _c(
                "div",
                { staticClass: "up-body" },
                [
                  _c("p", { staticClass: "up-intro" }, [
                    _vm._v(
                      "Para recibos sueltos, como una liquidación final o un ajuste."
                    ),
                  ]),
                  _c("BaseCombobox", {
                    attrs: {
                      label: "Legajo*",
                      name: "legajo",
                      items: _vm.legajoItems,
                      "item-text": "label",
                      "item-value": "id",
                      loading: _vm.loading_legajos,
                      rules: "required|combobox_required",
                      validationErrors: _vm.errors,
                    },
                    model: {
                      value: _vm.legajo,
                      callback: function ($$v) {
                        _vm.legajo = $$v
                      },
                      expression: "legajo",
                    },
                  }),
                  _c("PayslipPeriodFields", {
                    model: {
                      value: _vm.item,
                      callback: function ($$v) {
                        _vm.item = $$v
                      },
                      expression: "item",
                    },
                  }),
                  _c("div", { staticClass: "up-label" }, [
                    _vm._v("PDF del recibo*"),
                  ]),
                  _c("PdfDropZone", {
                    attrs: { error: _vm.file_error },
                    model: {
                      value: _vm.file,
                      callback: function ($$v) {
                        _vm.file = $$v
                      },
                      expression: "file",
                    },
                  }),
                  _vm.file_error
                    ? _c("span", { staticClass: "red--text" }, [
                        _vm._v("Elegí el PDF del recibo."),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "error",
                        text: "",
                        disabled: _vm.loading,
                      },
                      on: { click: _vm.close },
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "success",
                        text: "",
                        type: "submit",
                        loading: _vm.loading,
                      },
                    },
                    [_vm._v("Cargar")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }